const mergeObject = require('hobbit-base/modules/plugins/mergeObject');
const prodConfig = require('./prod');
const appName = require('../package.json').name;

// 只需定义要覆盖线上配置的内容即可
module.exports = mergeObject(prodConfig, {
  site: {
    publicPath: `https://s.vipkidstatic.com/fe-static/${appName}/pre/${process.env.VUE_APP_DRONE || 'default'}/`, // 静态资源部署目录
    outputDir: 'dist/pre',
    vconsole: true,
  },
  log: {
    consoleLog: true,
  },
  resources: {
    cacheExpires: 1 * 60 * 1000, // 资源缓存刷新间隔时间（毫秒数）
  },
  custom: {
  },
});
